import React, { Component } from 'react'
import PropTypes from 'prop-types'

class StaticsTableAverage extends Component {
    render() {
        const { data, loading, error } = this.props
        const { items = [] } = { ...data }
        const numCols = 10
        const totalPushedCount = items.reduce((sum, item) => sum + item.pushed_count, 0)
        const totalCompletedCount = items.reduce((sum, item) => sum + item.completed_count, 0)
        const totalOnTimeCount = items.reduce((sum, item) => sum + item.on_time_count, 0)
        const totalOvertimeCount = items.reduce((sum, item) => sum + item.overtime_count, 0)

        return (
            <div className="StaticsTableAverage text-center">
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th className='text-left'>SKU</th>
                            <th>Tổng items đẩy xưởng</th>
                            <th>Tổng items hoàn thành</th>
                            <th>Tỉ trọng sản xuất(%)</th>
                            <th>Số lượng items sản xuất trung bình / ngày</th>
                            <th>Thời gian sản xuất trung bình / Thời gian cam kết</th>
                            <th>Tổng items đúng hạn</th>
                            <th>Tổng items quá hạn</th>
                            <th>Số lỗi toàn bộ / tỉ lệ lỗi</th>
                            <th>Số lỗi chi tiết / tỉ lệ lỗi</th>
                            <th>Tổng số lỗi / tỉ lệ lỗi</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            loading === null && !!error && error.length > 0 && <tr>
                                <td colSpan={numCols} className='text-danger'>{error}</td>
                            </tr>
                        }

                        {
                            loading && <tr>
                                <td colSpan={numCols}>Loading...</td>
                            </tr>
                        }
                        {!loading && !!items && items.length > 0 &&
                            <tr>
                                <td className='font-weight-bold'></td>
                                <td className='font-weight-bold'>{totalPushedCount || 0}</td>
                                <td className='font-weight-bold'>{totalCompletedCount || 0}</td>
                                <td className='font-weight-bold'>-</td>
                                <td className='font-weight-bold'>-</td>
                                <td className='font-weight-bold'>-</td>
                                <td className='font-weight-bold'>{totalOnTimeCount || 0}</td>
                                <td className='font-weight-bold'>{totalOvertimeCount || 0}</td>
                                <td className='font-weight-bold'>-</td>
                                <td className='font-weight-bold'>-</td>
                                <td className='font-weight-bold'>-</td>
                            </tr>
                        }
                        {
                            !loading && !!items && items.length > 0 && items.map((item, index) => {
                                const {
                                    pushed_count,
                                    completed_count,
                                    rate_products,
                                    average_items_per_day,
                                    average_time_per_item,
                                    commitment_time,
                                    max,
                                    min,
                                    overtime_count,
                                    on_time_count,
                                    type,
                                    error_count,
                                    error_overview_count,
                                    error_detail_count,
                                    error_overview_rate,
                                    error_detail_rate,
                                    error_rate
                                } = item

                                return <tr key={index}>
                                    <td className='SKU text-left'>{type}</td>
                                    <td>{pushed_count || 0}</td>
                                    <td>{completed_count || 0}</td>
                                    <td>{rate_products || 0}</td>
                                    <td>{average_items_per_day || 0} ({min || 0} - {max || 0})</td>
                                    <td className={(average_time_per_item > commitment_time) ? 'text-danger' : 'text-success'}>
                                        {average_time_per_item || 0} / {commitment_time || 0}
                                    </td>
                                    <td>{on_time_count || 0}</td>
                                    <td>{overtime_count || 0}</td>
                                    <td>{error_overview_count || 0} / {error_overview_rate || 0}</td>
                                    <td>{error_detail_count || 0} / {error_detail_rate || 0}</td>
                                    <td>{error_count || 0} / {error_rate || 0}</td>
                                </tr>
                            })
                        }

                        {
                            error.length === 0 && !loading && items.length === 0 && <tr>
                                <td colSpan={numCols}>No data</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        )
    }
}

StaticsTableAverage.propTypes = {
    data: PropTypes.array.isRequired,
    loading: PropTypes.any,
    error: PropTypes.string
}

export default StaticsTableAverage
